import { render } from "./ModalExerciseDetails.vue?vue&type=template&id=2fe1f622&scoped=true&ts=true"
import script from "./ModalExerciseDetails.vue?vue&type=script&lang=ts"
export * from "./ModalExerciseDetails.vue?vue&type=script&lang=ts"

import "./ModalExerciseDetails.vue?vue&type=style&index=0&id=2fe1f622&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe1f622"]])

export default __exports__